import { createContext, useContext, useEffect, useState, useCallback } from "react";
import api from "@/lib/api";

const Ctx = createContext({ gender: "female", chosen: true, reload: () => {}, save: async () => {} });

export function BodyMapProvider({ children }) {
  const [state, setState] = useState({ gender: "female", chosen: true });

  const reload = useCallback(() => {
    api.get("/org/body-map").then((r) => setState({ gender: r.data.gender || "female", chosen: !!r.data.chosen })).catch(() => {});
  }, []);

  const save = useCallback(async (gender) => {
    const r = await api.put("/org/body-map", { gender });
    setState({ gender: r.data.gender, chosen: true });
    return r.data.gender;
  }, []);

  useEffect(() => { reload(); }, [reload]);

  return <Ctx.Provider value={{ ...state, reload, save }}>{children}</Ctx.Provider>;
}

export const useBodyMap = () => useContext(Ctx);
